<template>
  <div id="top" class="mainWrapper">
    <!--nav11-->
    <head-nav v-bind:gray="gray"></head-nav>
    <!--container1-->
    <div class="innerWrapper">
      <h1>
        Your account
        <button @click="logout">Log out</button>
      </h1>
      <h2>
        This section allows you to view your account details,
        {{ bonusText }} the amount of commissions to receive, your financial
        year income, access your invoices and properties that you have
        bookmarked, reserved and purchased.
      </h2>
    </div>
    <div class="detailWrapper">
      <div class="inn">
        <h1 v-bind:class="'tenant-' + tenant">Your details</h1>
        <p class="clear" style="display:flex">
          <span style="width:3rem">Company name:</span
          ><i>{{ user.companyName }}</i>
        </p>
        <p class="clear" style="display:flex">
          <span style="width:3rem">Name:</span
          ><i>{{ user.firstName }} {{ user.lastName }}</i>
        </p>
        <p class="clear" style="display:flex">
          <span style="width:3rem">Address:</span
          ><i
            >{{ user.address }}, {{ user.suburb }}, {{ user.state }},
            {{ user.postcode }}</i
          >
        </p>
        <p class="clear" style="display:flex">
          <span style="width:3rem">Phone number:</span
          ><i>{{ user.phoneNumber }}</i>
        </p>
        <p class="clear" style="display:flex">
          <span style="width:3rem">Mobile:</span><i>{{ user.mobileNumber }}</i>
        </p>
        <p class="clear" style="display:flex">
          <span style="width:3rem">Email:</span><i>{{ user.email }}</i>
        </p>
        <p class="clear" style="display:flex">
          <span style="width:3rem">C/C email:</span><i>{{ user.ccEmail }}</i>
        </p>
        <p class="clear" style="display:flex">
          <span style="width:3rem">ABN or ACN:</span><i>{{ user.abn }}</i>
        </p>
        <button @click="edit">Edit details</button>
      </div>
    </div>
    <div class="otherWrapper">
      <div v-show="false" class="banner">
        <!-- hide the bonus information -->
        <h3 v-if="sold.needSales > 0">
          You're at <span>{{ sold.alreadySales }} out of 5</span> sales for
          {{ month }}!
        </h3>
        <h3 v-else>Congratulations, you've earned the UNIFI bonus!</h3>
        <i class="lt"></i>
        <i class="lb"></i>
        <i class="rt"></i>
        <i class="rb"></i>
        <div class="icons">
          <!-- 如果全部售出，图标全部黄色 -->
          <div v-if="sold.alreadySales > 4" class="icon clear">
            <div
              v-for="(icon, index) in sold.iconList"
              :key="index"
              class="i yellow"
            ></div>
          </div>
          <div v-else class="icon clear">
            <div
              v-for="(icon, index) in sold.iconList"
              :key="index"
              :class="{
                white: icon.status == 'sold',
                hyline: icon.status == 'need'
              }"
              class="i"
            ></div>
          </div>
        </div>
        <p v-if="sold.needSales > 0">
          When you achieve 5 or more unconditional<br />sale contracts in a
          calendar month, UNIFI will reward you with a $5,000 bonus.<br /><span
            style="position: relative;top: .1rem;"
            >*Refer to FAQ page for payment terms</span
          >
        </p>
        <p v-else>
          You sold 5 houses this month and will now receive the $5,000 bonus!
        </p>
      </div>
      <h1 style="margin-bottom:.1rem;" v-bind:class="'tenant-' + tenant">
        Commission to receive
      </h1>
      <prevchart
        :barsHeight="barsHeight"
        :date="date"
        :price="ydata"
      ></prevchart>
      <h1 style="margin-bottom:.1rem" v-bind:class="'tenant-' + tenant">
        Financial year income
      </h1>
      <nextchart
        :barsHeight="barsHeight2"
        :date="date2"
        :price="ydata2"
      ></nextchart>
      <div class="list">
        <ul>
          <li :class="{ big: number > 0 }" class="clear">
            Invoices
            <button @click="toLst">View</button>
            <div v-if="number > 0" class="tip">
              {{ number }} new due invoice
            </div>
          </li>
          <li class="clear">
            Bookmarked properties
            <button @click="book">View</button>
          </li>
          <li class="clear">
            Reserved properties
            <button @click="reserve">View</button>
          </li>
          <li class="clear">
            Purchased properties
            <button @click="purchase">View</button>
          </li>
        </ul>
      </div>
    </div>
    <!--footer-->
    <foot-nav></foot-nav>
  </div>
</template>

<script>
import headNav from "@/components/package/nav";
import footNav from "@/components/package/footer";
import { mapActions } from "vuex";
import prevchart from "@/components/package/barChart";
import nextchart from "@/components/package/barSecondChart";

export default {
  data() {
    return {
      month: null,
      user: {},
      sold: {
        alreadySales: 5,
        iconList: [
          { status: "sold" },
          { status: "sold" },
          { status: "sold" },
          { status: "need" },
          { status: "need" }
        ]
      },
      gray: true,
      // 第一个报表的数据
      // barsHeight: [180, 80, 160, 200, 40, 118, 36, 60, 180, 36, 58, 36, 60],
      barsHeight: [],
      date: [],
      ydata: [],
      // 第二个报表的数据
      barsHeight2: [],
      date2: [],
      test: "",
      ydata2: [],
      // 消息通知数量
      number: 0,
      bonusText: "",
      tenant: window.location.hostname
        .replace("m.", "")
        .split(".")[0]
        .split("testunifiproperty")[0]
        .split("unifiproperty")[0]
        .split("platform")[0]
    };
  },
  created() {
    var that = this;
    (that.bonusText = false
      ? "the progress on your monthly $5,000 bonus, "
      : ""),
      // 获取用户详情
      that.getUserDtl({ callback: that.userCallback });
    // 获取第一个报表
    that.getCosByMon({ callback: that.listCallback });
    // 获取第二个报表
    that.getCosByYear({ callback: that.listYearCallback });
    // 获取已售房子情况
    that.getSoldList({ callback: that.soldCallback });
    // 获取消息通知
    that.getInvoiceNums({ callback: that.numCallback });
    // 获取当前月份
    let myDate = new Date();
    let tMonth = myDate.getMonth();
    let m = tMonth + 1;
    if (m == 1) {
      that.month = "January";
    } else if (m == 2) {
      that.month = "February";
    } else if (m == 3) {
      that.month = "March";
    } else if (m == 4) {
      that.month = "April";
    } else if (m == 5) {
      that.month = "May";
    } else if (m == 6) {
      that.month = "June";
    } else if (m == 7) {
      that.month = "July";
    } else if (m == 8) {
      that.month = "August";
    } else if (m == 9) {
      that.month = "September";
    } else if (m == 10) {
      that.month = "October";
    } else if (m == 11) {
      that.month = "November";
    } else if (m == 12) {
      that.month = "December";
    }
  },
  mounted() {
    document.getElementById("top").scrollIntoView();
  },
  methods: {
    ...mapActions("account", [
      "getUserDtl",
      "getCosByMon",
      "getSoldList",
      "getCosByYear",
      "getInvoiceNums"
    ]),
    ...mapActions("login", ["signOut", "change"]),
    logout() {
      this.$box.loadings();
      this.signOut({ callback: this.logoutcallback });
    },
    logoutcallback(res) {
      var that = this;
      that.$box.loadings(2);
      if (res.data.code == 0) {
        this.change({ data: "on" });
        localStorage.clear();
        that.$router.replace("/login");
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    // 按月报表
    listCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        if (res.data.data.totalPage == 0) {
          that.ydata = [
            "180,000",
            "150,000",
            "120,000",
            "90,000",
            "60,000",
            "30,000",
            "0"
          ];
          return;
        }
        const max = that.$box.formatMaxLst(res.data.data.totalPage);
        for (let i = 0; i < 7; i++) {
          if (i == 0) that.ydata.push(0);
          else that.ydata.push(that.$box.formatSplit((max / 6) * i, true));
        }
        that.ydata.reverse();
        res.data.data.list.forEach(v => {
          const height = (v.commission / max) * 199;
          const subHeight = (v.bounds / max) * 199;
          const year = new Date(v.beginTime * 1000).getFullYear();
          that.barsHeight.push(height + subHeight);
          const am = v.commission + v.bounds;
          that.date.push({
            month: v.monthName,
            year: year,
            all: height + subHeight,
            bonus: subHeight,
            nums: that.$box.formatSplit(am, false)
          });
        });
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      }
    },
    // 按年报表
    listYearCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        if (res.data.data.totalPage == 0) {
          that.ydata2 = [
            "350,000",
            "300,000",
            "250,000",
            "200,000",
            "150,000",
            "100,000",
            "50,000",
            "0"
          ];
          return;
        }
        const max = that.$box.formatMaxLst2(res.data.data.totalPage);
        for (let i = 0; i < 8; i++) {
          if (i == 0) that.ydata2.push(0);
          else that.ydata2.push(that.$box.formatSplit((max / 7) * i, true));
        }
        that.ydata2.reverse();
        var date = new Date();
        const curY = date.getFullYear();
        const curM = date.getMonth() + 1;
        const curD = date.getDate();

        var lastDay = new Date(curY, 6, 0).getDate();

        var cur = "";
        if (curM <= 6) {
          cur =
            JSON.stringify(curY - 1).slice(2) +
            "-" +
            JSON.stringify(curY).slice(2);
        } else {
          cur =
            JSON.stringify(curY).slice(2) +
            "-" +
            JSON.stringify(curY + 1).slice(2);
        }
        res.data.data.list.forEach(v => {
          const height = (v.commission / max) * 229;
          that.barsHeight2.push(height);
          if (v.yearName == cur) {
            //v.yearName = 'Current'
          }
          that.date2.push({
            month: v.yearName,
            all: height,
            nums: that.$box.formatSplit(v.commission, false)
          });
        });
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      }
    },
    // 获取用户详情的回调
    userCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        //res.data.data.phoneNumber = (that.$box.formatTelNumber(res.data.data.phoneNumber)).replace(/(^\s*)|(\s*$)/g, "");
        //res.data.data.mobileNumber = (that.$box.formatTelNumber(res.data.data.mobileNumber)).replace(/(^\s*)|(\s*$)/g, "");
        res.data.data.abn = that.$box
          .formatAbn(res.data.data.abn)
          .replace(/(^\s*)|(\s*$)/g, "");
        res.data.data.email = res.data.data.email.replace(/(^\s*)|(\s*$)/g, "");
        res.data.data.ccEmail = res.data.data.ccEmail.replace(
          /(^\s*)|(\s*$)/g,
          ""
        );
        res.data.data.address = res.data.data.address.replace(
          /(^\s*)|(\s*$)/g,
          ""
        );
        res.data.data.suburb = res.data.data.suburb.replace(
          /(^\s*)|(\s*$)/g,
          ""
        );
        res.data.data.state = res.data.data.state.replace(/(^\s*)|(\s*$)/g, "");
        res.data.data.postcode = res.data.data.postcode.replace(
          /(^\s*)|(\s*$)/g,
          ""
        );
        res.data.data.firstName = res.data.data.firstName.replace(
          /(^\s*)|(\s*$)/g,
          ""
        );
        res.data.data.lastName = res.data.data.lastName.replace(
          /(^\s*)|(\s*$)/g,
          ""
        );
        res.data.data.companyName = res.data.data.companyName.replace(
          /(^\s*)|(\s*$)/g,
          ""
        );
        that.user = res.data.data;
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      }
    },
    // 获取已售房子情况的回调
    soldCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        res.data.data.iconList = [];
        for (let i = 0; i < 5; i++) {
          if (i < res.data.data.alreadySales) {
            res.data.data.iconList.push({
              status: "sold"
            });
          } else {
            res.data.data.iconList.push({
              status: "need"
            });
          }
        }
        that.sold = res.data.data;
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      }
    },
    // 获取消息通知回调
    numCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        that.number = res.data.data;
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      }
    },
    edit() {
      this.$router.push("/account/edit");
    },
    book() {
      this.$router.push("/account/book");
    },
    reserve() {
      this.$router.push("/account/reserve");
    },
    purchase() {
      this.$router.push("/account/purchase");
    },
    toLst() {
      this.$router.push("/account/invoice");
    }
  },
  components: {
    headNav,
    footNav,
    prevchart,
    nextchart
  }
};
</script>

<style lang="scss" scoped>
.mainWrapper {
  width: 100%;
  position: relative;
}

.innerWrapper {
  width: 100%;
  margin: 0 auto;
  padding: 0 0.32rem;
  padding-top: 1.52rem;
  box-sizing: border-box;

  h1 {
    font-size: 0.56rem;
    color: #2a2929;
    line-height: 0.68rem;
    margin-bottom: 0.32rem;
    font-family: ProximaNova-Semibold;
    position: relative;

    button {
      position: absolute;
      right: 0;
      top: 0;
      outline: none;
      background: none;
      border: 2px solid rgba(255, 78, 78, 1);
      box-sizing: border-box;
      width: 1.6rem;
      height: 0.6rem;
      line-height: 0.6rem;
      padding: 0;
      font-size: 0.3rem;
      font-family: ProximaNova-Semibold;
      color: rgba(255, 78, 78, 1);
      border-radius: 0.12rem;
      cursor: pointer;
    }
  }

  h2 {
    font-size: 0.28rem;
    line-height: 0.42rem;
    margin-bottom: 0.8rem;
    color: #3f3f46;
    word-break: break-word;
  }
}

.detailWrapper {
  width: 100%;
  background: #f5f5f7;
  padding: 0.58rem 0.48rem;
  margin-bottom: 0.4rem;
  box-sizing: border-box;

  .inn {
    width: 100%;
    margin: 0 auto;

    h1 {
      font: size 0.46r;
      color: #333333;
      line-height: 0.56rem;
      position: relative;
      margin-bottom: 0.48rem;
    }

    h1:after {
      content: "";
      width: 1.16rem;
      height: 0.06rem;
      display: block;
      position: absolute;
      left: 0;
      bottom: -6px;
      //background: #FFEF00;
    }

    button {
      border: none;
      display: block;
      margin: 0.48rem auto 0 auto;
      text-align: center;
      line-height: 0.92rem;
      width: 5.18rem;
      height: 0.92rem;
      box-sizing: border-box;
      border-radius: 6px;
      font-size: 0.28rem;
      background: #2cca73;
      color: #fff;
      cursor: pointer;
    }

    p {
      color: #8f8f8f;
      margin-bottom: 0.14rem;
      font-size: 0.28rem;
      line-height: 0.38rem;

      i {
        font-style: normal;
        color: #3f3f46;
        width: 4.22rem;
        flex: 1;
        text-align: right;
        text-align: -webkit-right;
        // margin-left: auto;
      }
    }
  }
}

.otherWrapper {
  width: 100%;
  margin: 0 auto;
  padding: 0.32rem;
  box-sizing: border-box;

  .banner {
    width: 100%;
    height: 5.04rem;
    border-radius: 3px;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    background-image: url("https://s3.ap-southeast-2.amazonaws.com/com.unifiproperty/files/images/202007mEMGh7wCIz");
    position: relative;
    margin-bottom: 0.8rem;

    i {
      position: absolute;
      height: 0.48rem;
      width: 0.48rem;
      display: block;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
    }

    .lt {
      top: 0.18rem;
      left: 12px;
      background-image: url("../../assets/lt.png");
    }

    .lb {
      bottom: 12px;
      left: 12px;
      background-image: url("../../assets/lb.png");
    }

    .rt {
      top: 12px;
      right: 12px;
      background-image: url("../../assets/rt.png");
    }

    .rb {
      bottom: 12px;
      right: 12px;
      background-image: url("../../assets/rb.png");
    }

    h3 {
      padding: 0.48rem 0.86rem 0 0.86rem;
      font-size: 0.46rem;
      line-height: 0.7rem;
      margin-bottom: 0.32rem;
      color: #fff;
      font-family: ProximaNova-Semibold;
      text-align: center;

      span {
        color: #ffef00;
      }
    }

    .icons {
      width: 100%;
      text-align: center;

      .icon {
        display: inline-block;

        .i {
          display: block;
          width: 0.94rem;
          height: 0.87rem;
          float: left;
          margin-right: 0.24rem;
          background-size: contain;
          background-position: center center;
          background-repeat: no-repeat;
        }

        .i:nth-last-child(1) {
          margin: 0;
        }

        .white {
          background-image: url("../../assets/hh.png");
        }

        .hyline {
          background-image: url("../../assets/hh.png");
          opacity: 0.3;
        }

        .yellow {
          background-image: url("../../assets/yh.png");
        }
      }
    }

    p {
      font-size: 0.27rem;
      line-height: 0.42rem;
      padding: 0 0.6rem;
      text-align: center;
      color: #fff;
    }
  }

  h1 {
    font-size: 0.48rem;
    color: #333333;
    line-height: 0.58rem;
    position: relative;
    margin-bottom: 0.6rem;
  }

  h1:after {
    content: "";
    width: 1.16rem;
    height: 0.06rem;
    display: block;
    position: absolute;
    left: 0;
    bottom: -6px;
    //background: #FFEF00;
  }

  .echart {
    width: 100%;
    height: 3.36rem;
    position: relative;
    margin-bottom: 0.8rem;

    .lft {
      position: absolute;
      left: 0;
      top: 0;

      li {
        font-size: 14px;
        line-height: 17px;
        margin-bottom: 16px;
        color: #3f3f46;
      }
    }

    .rgt {
      width: 100%;
      float: right;

      .top {
        width: 100%;
        height: 206px;
        box-sizing: border-box;
        border-left: 1px solid #dee3e0;
        border-bottom: 1px solid #dee3e0;
        position: relative;
        margin-bottom: 15px;

        .lines {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          z-index: 1;

          .line {
            position: absolute;
            left: 0;
            width: 100%;
            border-top: 1px solid #dee3e0;
          }

          .line:nth-child(1) {
            top: 7px;
          }

          .line:nth-child(2) {
            top: 40px;
          }

          .line:nth-child(3) {
            top: 73px;
          }

          .line:nth-child(4) {
            top: 106px;
          }

          .line:nth-child(5) {
            top: 139px;
          }

          .line:nth-child(6) {
            top: 172px;
          }

          .line:nth-child(7) {
            top: 205px;
          }
        }

        .bars {
          position: absolute;
          left: 0;
          bottom: 0;

          .bar {
            float: left;
            width: 58px;
            height: 206px;
            position: relative;
            z-index: 2;

            .box {
              width: 16px;
              background: rgba(63, 63, 70, 1);
              border-radius: 3px 3px 0px 0px;
              position: absolute;
              left: 21px;
              bottom: 0;
            }

            .grnBox {
              width: 16px;
              background: #2cca73;
              border-radius: 3px 3px 0px 0px;
              position: absolute;
              left: 21px;

              span {
                display: block;
                position: absolute;
                left: -21px;
                width: 58px;
                height: 45px;
                background-size: contain;
                background-position: center center;
                background-repeat: no-repeat;
                background-image: url("../../assets/bonus.png");
              }
            }

            .nums {
              width: 16px;
              position: absolute;
              left: 21px;

              .inn {
                text-align: center;
                font-size: 12px;
                color: #3f3f46;
                font-family: ProximaNova-Semibold;
                width: 100px;
                position: absolute;
                left: -42px;
                top: 0;
              }
            }
          }
        }

        .svg {
          position: absolute;
          left: 0;
          top: 0;
          height: 206px;
          width: 100%;
        }
      }

      .btm {
        width: 100%;
        box-sizing: border-box;

        li {
          float: left;
          width: 58px;
          text-align: center;
          font-size: 14px;
          padding-top: 1.5px;
          color: #3f3f46;

          span {
            display: block;
            color: #a3a1a4;
            margin-top: 6px;
          }
        }
      }
    }
  }

  .list {
    margin-bottom: 0.6rem;

    li {
      width: 100%;
      box-sizing: border-box;
      height: 1.28rem;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.06);
      border-radius: 2px;
      border: 1px solid rgba(247, 247, 250, 1);
      margin-bottom: 0.28rem;
      padding: 0 0.36rem;
      line-height: 1.28rem;
      color: #333333;
      font-size: 0.32rem;

      button {
        float: right;
        border: none;
        text-align: center;
        line-height: 0.56rem;
        width: 1.2rem;
        height: 0.56rem;
        background: rgba(44, 202, 115, 1);
        border-radius: 6px;
        font-size: 0.28rem;
        color: #fff;
        margin-top: 0.36rem;
        cursor: pointer;
      }

      .tip {
        width: 2.7rem;
        float: right;
        font-size: 0.24rem;
        line-height: 1.28rem;
        height: 1.28rem;
        color: #ff4e4e;
        margin: 0 0.32rem 0 0;
        padding-left: 0.46rem;
        background-size: 0.4rem 0.4rem;
        background-position: left center;
        background-repeat: no-repeat;
        background-image: url("../../assets/r.png");
      }
    }

    .big {
      position: relative;
      height: 1.6rem;
      line-height: 1rem;

      .tip {
        position: absolute;
        left: 0.42rem;
        top: 0.4rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/account.vue